<template>
    <div class="range-indicator d-flex justify-content-center align-items-center">
        <div
            class="mr-3"
            v-if="startLabel">
            {{ startLabel }}
        </div>
        <input
            type="range"
            :min="min"
            :max="max"
            :value="value"
            disabled="disabled" />
        <div
            class="ml-3"
            v-if="endLabel">
            {{ endLabel }}
        </div>
    </div>
</template>

<script>
    import { start } from 'vue2-timepicker';

    export default {
        name: 'design-2021-apprentice-range-indicator-component',
        methods: { start },
        props: {
            color: {
                type: String,
                required: true,
            },
            min: {
                type: Number,
                required: true,
            },
            max: {
                type: Number,
                required: true,
            },
            value: {
                type: Number,
                required: true,
            },
            startLabel: {
                type: [String, null],
                default: null,
            },
            endLabel: {
                type: [String, null],
                default: null,
            },
        },
    };
</script>

<style scoped lang="scss">
    .range-indicator {
        $track-color: v-bind('color');
        $track-background-color: v-bind('color');
        $thumb-color: v-bind('color');

        input[type='range'] {
            -webkit-appearance: none;
            width: 100%;
            background: none;
            margin: 0;

            // Track style
            &::-webkit-slider-runnable-track,
            &::-moz-range-track {
                height: 8px;
                background: linear-gradient(to right, $track-color 50%, $track-background-color 50%);
                border-radius: 5px;
            }

            // Thumb style
            &::-webkit-slider-thumb,
            &::-moz-range-thumb {
                -webkit-appearance: none;
                height: 25px;
                width: 25px;
                background-color: $thumb-color; // Thumb color
                border: none;
                border-radius: 50%;
                cursor: pointer;
            }

            // Disabled thumb for non-draggable case
            &:disabled::-webkit-slider-thumb,
            &:disabled::-moz-range-thumb {
                pointer-events: none;
            }
        }
    }
</style>
